const statuses = [
  {
    label: 'Active',
    value: 'active',
    code: 1,
  },
  {
    label: 'Quote',
    value: 'quote',
    code: 2,
  },
  {
    label: 'Cancelled',
    value: 'blocked',
    code: 3,
  },
  {
    label: 'Overdue',
    value: 'overdue',
    code: 4,
  },
];

export default statuses;
